import { render, staticRenderFns } from "./AnswerTypeCheckbox.vue?vue&type=template&id=db8b4808&scoped=true"
import script from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeCheckbox.vue?vue&type=style&index=0&id=db8b4808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8b4808",
  null
  
)

export default component.exports